const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getBankDetails = async (connectionId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/get-bank-details/${connectionId}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const jsonData = await response.json();
    //console.log("System config data:", jsonData);
    
    return jsonData;
    
  } catch (error) {
    console.error("Error fetching system config:", error);
    throw error;
  }
}
export const updateBankDetails = async (connectionId, bankDetails) => {
  try {
    const response = await fetch(`${API_BASE_URL}/update-bank-details/${connectionId}`, {
      method: 'PUT', // or PATCH
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
      body: JSON.stringify(bankDetails),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to update bank details');
    }

    const data = await response.json();
    return data; // { success, message, data }
  } catch (error) {
    console.error('Error updating bank details:', error);
    throw error;
  }
};


